// extracted by mini-css-extract-plugin
module.exports = {"pvfWrapper":"yzKj4","pvfNameTitle":"EnUdS","pvfCustomTitle":"LB98i"};